var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.078,
    height: 16.224,
    viewBox: "0 0 17.078 16.224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#444f7a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.516,5.062H11.154l-.273-.854A2.562,2.562,0,0,0,8.456,2.5H4.562A2.562,2.562,0,0,0,2,5.062v11.1a2.562,2.562,0,0,0,2.562,2.562H16.516a2.562,2.562,0,0,0,2.562-2.562V7.623A2.562,2.562,0,0,0,16.516,5.062Zm.854,11.1a.854.854,0,0,1-.854.854H4.562a.854.854,0,0,1-.854-.854V5.062a.854.854,0,0,1,.854-.854H8.456a.854.854,0,0,1,.811.581l.461,1.4a.854.854,0,0,0,.811.581h5.977a.854.854,0,0,1,.854.854Z",
    transform: "translate(-2 -2.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.35bca63518d8d2e287548696d49c9ad5.svg";
export { ForwardRef as ReactComponent };